import React, { useState, useEffect } from 'react';
// import Modal from 'react-bootstrap/Modal';
import Block from '../block';
import { RichText } from '../richTextOptions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsPreviewStatus } from '../../state/app';
import { Popup } from './Common/Popup'
import { replaceStateShortCodes } from '../utilities';


const MemberEnjoyBlock = (props) => {
     const { iconSvg, anchorText, headline, blockClass, isPreview, enjoyDescription, showPopupModal } = props;
     return (
          enjoyDescription ?
               (
                    <div className={`member-enjoy member-enjoy-popup-anchor ${blockClass ? blockClass : ''}`}>
                         <div
                              tabIndex="0"
                              className="popup-headline"
                              onClick={showPopupModal}
                              onKeyPress={(e) => {
                                   if (e.key === 'Enter') {
                                        showPopupModal()
                                   }
                              }}
                         >
                              {(iconSvg && isPreview ? iconSvg : iconSvg.childMarkdownRemark.html) && <span className="icon" dangerouslySetInnerHTML={{ __html: isPreview ? iconSvg : iconSvg.childMarkdownRemark.html }}></span>}
                              <div className="headline-text">
                                   <RichText data={anchorText ? anchorText : headline} />
                              </div>
                         </div>
                         <div className="enjoy-description"><RichText data={enjoyDescription} /></div>
                    </div>
               ) : (
                    <div className={`member-enjoy member-enjoy-popup-anchor ${blockClass ? blockClass : ''}`}>
                         <div
                              tabIndex="0"
                              className="popup-headline"
                              onClick={showPopupModal}
                              onKeyPress={(e) => {
                                   if (e.key === 'Enter') {
                                        showPopupModal()
                                   }
                              }}
                         >
                              {(iconSvg && isPreview ? iconSvg : iconSvg.childMarkdownRemark.html) && <span className="icon" dangerouslySetInnerHTML={{ __html: isPreview ? iconSvg : iconSvg.childMarkdownRemark.html }}></span>}
                              <div className="headline-text">
                                   <RichText data={anchorText ? anchorText : headline} />
                              </div>
                         </div>
                    </div>
               )
     )



}
const BlockMemberEnjoyPopup = (props) => {
     const [showPopup, setShowPopup] = useState(false)
     const handleClosePopup = () => setShowPopup(false);
     const handleShowPopup = () => setShowPopup(true);
     const { iconSvg, headline, subHeadline, contents, layoutTemplate, blockClass, isPreview, bottomNote } = props;
     let layoutClass = layoutTemplate ? layoutTemplate.replace(/ /g, '-').toLowerCase() : null;

     useEffect(() => {
          const pageName = localStorage.getItem('pageName');
          if (pageName) {
               replaceStateShortCodes(pageName);
          }
     }, [])

     return (
          <>
               <MemberEnjoyBlock {...props} showPopupModal={handleShowPopup} />

               <Popup className={`member-enjoy-popup ${blockClass ? blockClass : ''}`} show={showPopup} onHide={handleClosePopup}>
                    <button tabIndex={showPopup ? 0 : -1} className="close" onClick={handleClosePopup} aria-label="Close">
                         <span>Close X</span>
                    </button>
                    <div className={`member-enjoy popup-content ${layoutClass ? layoutClass : ''}`}>
                         <div className="popup-headline">
                              {(iconSvg && isPreview ? iconSvg : iconSvg.childMarkdownRemark.html) && <span className="icon" dangerouslySetInnerHTML={{ __html: isPreview ? iconSvg : iconSvg.childMarkdownRemark.html.replace(/id=/g, 'data-id=') }}></span>}
                              <div className="headline-text">
                                   <RichText data={headline} />
                              </div>
                         </div>
                         <div className="popup-content">
                              <div className="sub-headline">
                                   <RichText data={subHeadline} />
                              </div>
                              <div className="content-row">
                                   {contents.map((block, i) => {
                                        return (<div key={i} className="col"><Block block={block} /></div>)
                                   })}
                              </div>

                              {
                                   bottomNote && (
                                        <div className="enjoy-bottom-note"><RichText data={bottomNote} /></div>
                                   )
                              }
                              {/* {button && buttonOnlyClose !== 'Yes' && (
                                        <div className="cta-button">
                                             <Block block={button} />
                                        </div>
                                   )}

                                   {buttonOnlyClose === 'Yes' &&
                                        (
                                             <div className="cta-button">
                                                  <div className="button-custom">
                                                       {
                                                            button.sys ? (
                                                                 <a onClick={this.handleClosePopup} href="JavaScript:void(0);" className={'button-' + button.fields.buttonStyle.toLowerCase() + (button.fields.buttonClass ? ' ' + button.fields.buttonClass : '')}>
                                                                      <span className="btn-desktop">{button.fields.buttonText}</span>
                                                                      <span className="btn-mobile">{button.fields.buttonTextMobile || button.fields.buttonText}</span>
                                                                 </a>
                                                            ) : (
                                                                      <a onClick={this.handleClosePopup} href="JavaScript:void(0);" className={'button-' + button.buttonStyle.toLowerCase() + (button.buttonClass ? ' ' + button.buttonClass : '')}>
                                                                           <span className="btn-desktop">{button.buttonText}</span>
                                                                           <span className="btn-mobile">{button.buttonTextMobile || button.buttonText}</span>
                                                                      </a>
                                                                 )
                                                       }

                                                  </div>
                                             </div>

                                        )
                                   } */}
                         </div>
                    </div>
               </Popup>
          </>
     );
};

BlockMemberEnjoyPopup.propTypes = {
     isPreview: PropTypes.bool
}

const mapStateToProps = (state) => {
     return {
          isPreview: getIsPreviewStatus(state)
     }
}

const ContentfulBlockMemberEnjoyPopup = connect(mapStateToProps)(BlockMemberEnjoyPopup);

export { ContentfulBlockMemberEnjoyPopup }